// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"de78ae76","453":"bed69e83","455":"2a99a00d"}[chunkId] + ".chunk.js";
};